import { createContext, useContext, useMemo } from 'react';
import titan, { TitanClient } from '@narvar/titan-client';

export interface TitanAnalyticsOptions {
  sourceWriteKey: string;
  dataPlaneUrl: string;
}

export const TitanAnalyticsContext = createContext<
  TitanAnalyticsOptions | undefined
>(undefined);

export const TitanAnalyticsProvider = TitanAnalyticsContext.Provider;

const useTitanAnalytics = () => {
  const context = useContext(TitanAnalyticsContext);

  const { sourceWriteKey, dataPlaneUrl } = context ?? {};

  const titanAnalytics = useMemo<TitanClient | undefined>(() => {
    if (!sourceWriteKey || !dataPlaneUrl) {
      return undefined;
    }

    // titan relies on browser crypto API
    if (typeof window !== 'undefined') {
      return titan({
        sourceWriteKey,
        url: dataPlaneUrl,
      });
    }

    return undefined;
  }, [sourceWriteKey, dataPlaneUrl]);

  return titanAnalytics;
};

export default useTitanAnalytics;
